<title>{{ additionalContentPage.htmlTitle }}</title>
<app-banner [banner]="additionalContentPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<app-additional-page-emergency-banner *ngIf="additionalContentPage.emergencyBanners?.length" [emergencyBanners]="additionalContentPage.emergencyBanners"></app-additional-page-emergency-banner>
<div class="container mt-5 templatePage mb-5">
<app-additional-page-section *ngIf="additionalContentPage.introductionSections?.length" [sections]="additionalContentPage.introductionSections"></app-additional-page-section>
<ng-container *ngFor="let item of additionalContentPage.mixedOrderSections">
  <app-additional-page-section *ngIf="item.type === 'section'" [sections]="[item.section]"></app-additional-page-section>
  <app-functional-capabilities-ribbon-tile-section *ngIf="item.type === 'ribbon'" [isRibbonTile]="true"
    [ribbonTileSections]="[item.ribbon]">
  </app-functional-capabilities-ribbon-tile-section>
</ng-container>
  <app-additional-section-card
    *ngIf="additionalContentPage.additionalSectionCardsAboveTable?.length"
    [additionalSectionCards]="additionalContentPage.additionalSectionCardsAboveTable"
  ></app-additional-section-card>
  <div *ngIf="additionalContentPage.image && additionalContentPage.imageSections">
    <div class="divide mb-5 row">
      <div class="col-sm-6 mt-2">
        <img src="{{ additionalContentPage.image }}" />
      </div>
      <div class="col-sm-6 mt-2">
        <app-additional-page-section [sections]="additionalContentPage.imageSections"></app-additional-page-section>
      </div>
    </div>
  </div>
  <app-additional-page-table-section *ngIf="additionalContentPage.tableSections?.length" [tableSections]="additionalContentPage.tableSections"></app-additional-page-table-section>
  <app-additional-page-section *ngIf="additionalContentPage.belowNoteSections?.length" [sections]="additionalContentPage.belowNoteSections"></app-additional-page-section>
  <app-additional-page-accordian-section
    *ngIf="additionalContentPage.accordianSections?.length"
    [additionalAccordianSections]="additionalContentPage.accordianSections"
  ></app-additional-page-accordian-section>
  <div class="m-5">
    <app-additional-page-carousel-section
      *ngIf="additionalContentPage.additionalCardCarousel?.length"
      [additionalCarousalSectionCards]="additionalContentPage.additionalCardCarousel"
    ></app-additional-page-carousel-section>
    <app-additional-section-card
      *ngIf="additionalContentPage.additionalSectionCardsBelowTable?.length"
      [additionalSectionCards]="additionalContentPage.additionalSectionCardsBelowTable"
    ></app-additional-section-card>
  </div>
</div>
